import * as rewardConst from "./constants";
import moment from "moment";
import { makeCall } from "@/utils/request";
import { buildOptions, getEndPoints } from "@/utils/api-call";
import { EVENT_TOAST_MESSAGE } from "@/store/events";
import { EventBus } from "@/event-bus";
export const state = {
  rewardAccessToken: {},
  rewardAccessTokens: [],
  pagination: {
    count: 10,
    total: 0
  }
};

export const getters = {
  [rewardConst.GETTER_REWARD_ACCESS_TOKEN]: state => {
    return state.rewardAccessToken;
  },
  [rewardConst.GETTER_LIST_REWARD_ACCESS_TOKEN]: state => {
    return state.rewardAccessTokens;
  },
  [rewardConst.GETTER_LIST_REWARD_ACCESS_TOKEN_PAGINATION]: state => {
    return state.pagination;
  }
};

export const actions = {
  [rewardConst.ACTION_SET_REWARD_ACCESS_TOKEN_STATE]: ({ commit }, data) => {
    commit(rewardConst.MUTATION_SET_REWARD_ACCESS_TOKEN, data);
  },
  [rewardConst.ACTION_GET_LIST_REWARD_ACCESS_TOKEN]: ({ commit }, options) => {
    const url = getEndPoints().program_rewards.getListRewardAccessToken;
    makeCall(url, buildOptions("GET", options), commit).then(response => {
      if (response.data) {
        commit(rewardConst.MUTATION_SET_LIST_REWARD_ACCESS_TOKEN, response);
      }
    });
  },
  [rewardConst.ACTION_GET_REWARD_ACCESS_TOKEN_DETAIL]: (
    { commit },
    options
  ) => {
    const url = getEndPoints().program_rewards.getRewardAccessTokenDetail.replace(
      ":id",
      options.id
    );
    makeCall(url, buildOptions("GET", options), commit).then(response => {
      if (response) {
        commit(rewardConst.MUTATION_SET_REWARD_ACCESS_TOKEN, response);
      }
    });
  },
  [rewardConst.ACTION_ADD_REWARD_ACCESS_TOKEN]: ({ commit }, options) => {
    const url = getEndPoints().program_rewards.createTremendousTeam;
    makeCall(url, buildOptions("POST", options.data), commit).then(
      response => {
        if (response.teamId && response.teamId.length > 0) {
          const urlGenerateToken = getEndPoints().program_rewards
            .generateAccessToken;
          let objCreateToken = options.data;
          objCreateToken.teamId = response.teamId;
          objCreateToken.id = response.id;
          makeCall(
            urlGenerateToken,
            buildOptions("POST", objCreateToken),
            commit
          ).then(
            () => {
              EventBus.$emit(EVENT_TOAST_MESSAGE, "Token saved successful!");
              options.callback(response);
            },
            error => {
              console.log("Error Generate Token:", error);
            }
          );
        }
      },
      error => {
        console.log("Error Create Team Name", error);
      }
    );
  },
  [rewardConst.ACTION_EDIT_REWARD_ACCESS_TOKEN]: ({ commit }, options) => {
    const url = getEndPoints().program_rewards.generateAccessToken;
    makeCall(url, buildOptions("POST", options.data), commit).then(response => {
      if (options.callback) {
        EventBus.$emit(EVENT_TOAST_MESSAGE, "Token saved successful!");
        options.callback(response);
      }
    });
  },
  [rewardConst.ACTION_DELETE_REWARD_ACCESS_TOKEN]: ({ commit }, options) => {
    if (options && options.id) {
      const url = getEndPoints().program_rewards.deleteRewardAccessToken.replace(
        ":id",
        options.id
      );
      makeCall(url, buildOptions("DELETE", {}), commit).then(() => {
        EventBus.$emit(EVENT_TOAST_MESSAGE, "Token deleted successful!");
        if (options.callback) {
          options.callback();
        }
      });
    }
  }
};

export const mutations = {
  [rewardConst.MUTATION_SET_REWARD_ACCESS_TOKEN]: (state, data) => {
    if (data.accessToken && data.accessToken.length > 0) {
      let text = data.accessToken;
      if (text.length > 3) {
        data.accessToken =
          "xxxxxxxxxxxxxxxxxxxxx" +
          text.substring(text.length - 3, text.length);
      } else {
        data.accessToken = "xxxxxxxxxxxxxxxxxxxxx" + text;
      }
    }
    state.rewardAccessToken = {
      Client: {
        ClientId: data.clientId,
        ClientName: data.clientName
      },
      Program: {
        ProgramId: data.programId,
        ProgramName: data.programName
      },
      AvailableCents: data.available_cents,
      Method: data.method,
      FundingId: data.fundingId,
      TeamId: data.teamId,
      TeamName: data.teamName,
      AccessToken: data.accessToken,
      UpdatedDate: moment(data.updatedDate).format("MM/DD/YYYY HH:mm"),
      UpdatedBy: data.updatedBy,
      Id: data.id
    };
  },
  [rewardConst.MUTATION_SET_LIST_REWARD_ACCESS_TOKEN]: (
    state,
    rewardAccessTokens
  ) => {
    const temp = rewardAccessTokens;
    [...temp.data].forEach(element => {
      if (element.accessToken && element.accessToken.length > 0) {
        let text = element.accessToken;
        if (text.length > 3) {
          element.accessToken =
            "xxxxxxxxxxxxxxxxxxxxx" +
            text.substring(text.length - 3, text.length);
        } else {
          element.accessToken = "xxxxxxxxxxxxxxxxxxxxx" + text;
        }
      }
    });
    state.rewardAccessTokens = rewardAccessTokens.data;
    state.pagination =
      rewardAccessTokens.meta && rewardAccessTokens.meta.pagination
        ? {
            ...{
              count: rewardAccessTokens.meta.pagination.count,
              total: parseInt(rewardAccessTokens.meta.pagination.total),
              itemsPerPage: rewardAccessTokens.meta.pagination.per_page,
              totalPage: rewardAccessTokens.meta.pagination.total_pages,
              current_page: parseInt(
                rewardAccessTokens.meta.pagination.current_page
              )
            }
          }
        : state.pagination;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_rewards_access_token/index.js